export function swipeSlideOnFocus(rootElement, swiperInstance, options = {}) {
  const slideElementSelector = options.slideElementSelector || ".swiper-slide";
  rootElement.addEventListener("focusin", (event) => {
    const slideElement = event.target.closest(slideElementSelector);
    if (!slideElement) {
      return;
    }
    const slides = [...slideElement.parentElement.children];
    const index = slides.indexOf(slideElement);
    swiperInstance.slideTo(index);
    swiperInstance.update();
  });
}
